const ROLES = {
    ROOT:'99999',
    TEMPLATE_MANAGEMENT:'20000',
    EVENT_LIST:'21000',
    EVENT_SAVE:'21100',
    EVENT_DELETE:'21200',
    EVENT_BULK_SEND: '21001',
    TEMPLATE_LIST:'21300',
    TEMPLATE_TEST_SEND:'21310',
    TEMPLATE_SAVE:'21320',
    TEMPLATE_DELETE:'21330',
    MAIL_LAYOUT_MANAGEMENT:'30000',
    MAIL_LAYOUT_LIST:'31000',
    MAIL_LAYOUT_SAVE:'31100',
    MAIL_LAYOUT_DELETE:'31200',
    SEND_LOG:'40000',
    SETTINGS:'50000',
    SETTINGS_CODE:'51000',
    SETTINGS_CODE_SAVE:'51100',
    SETTINGS_USER:'52000',
    SETTINGS_USER_SAVE:'52100',
}
export default {
    GETTERS : {
        LANGUAGE_OPTIONS: 'getLanguageOptions',
        FULL_LANGUAGE_OPTIONS: 'getFullLanguageOptions',
        CLIENT_CD_OPTIONS: 'getClientCdOptions',
        NOTI_CATE_CD_OPTIONS: 'EventsMessageMng/getNotiCateCdOptions',
        NOTI_TYPE_CD_OPTIONS: 'EventsMessageMng/getNotiTypeCdOptions',
        LAYOUT_OPTIONS: 'EventsMessageMng/getLayoutOptions',
        MSG_TYPE_OPTIONS:'EventsMessageMng/getMsgTypeOptions',
        QUEUE_TYPE_OPTIONS: 'EventsMessageMng/getQueueTypeOptions',
        LOG_STATUS_TYPE_OPTIONS:'EventsMessageMng/getLogStatusTypeOptions',
        LAYOUTS: 'EventsMessageMng/getLayouts',
        PARAMETER_COUNT_OPTIONS:'EventsMessageMng/getParameterCountOptions',
        PARAMETER_SUBJECT_COUNT_OPTIONS:'EventsMessageMng/getParameterSubjectCountOptions',
        STORED_EVENT_INFO:'EventsMessageMng/getStoredEventInfo',
        GET_USER:'auth/getUser',
        GET_USER_ROLE: 'auth/getUserRole',
        GET_LEGACY_PARAMS: 'getLegacyParams',
        SENDER_OPTIONS: 'getSenderOptions',
        GET_SENDER_LIST: 'getSenderList'
    },
    ACTIONS : {
        SET_LAYOUTS: 'EventsMessageMng/setLayouts',
        SET_STORED_EVENT_INFO:'EventsMessageMng/setStoredEventInfo',
        CALL_EVENT_INFO: 'EventsMessageMng/callEventInfo',
        SET_CLIENT_CD:'setClientCd',
        INIT_USER:'auth/initUser',
        SET_SENDER_LIST: 'setSenderList'
    },
    MUTATE : {
        SET_LEGACY_PARAMS: 'setLegacyParams',
    },
    REGEX: {
        EDITOR:/^{{([1-9]{1,1})(\:)([S|A|C|T|D|H|M|m|c|U|Y])}}/g,
        STRING_ANALYSIS:/{{([1-9]{1,1})(\:)([S|A|C|T|D|H|M|m|c|U|Y])}}/g
    },
    MSG_TYPE: {
        SMS: '1',
        MAIL: '2',
        APP_PUSH: '3',
        LINE_OA: '4',
        LINE_1TO1: '5',
        NOTIFICATION: '9'
    },
    QUEUE_TYPE: {
      Regular: 'R',
      Premium: 'P',
    },
    PERIOD_TYPE: {
        RELATIVE: 0,
        ABSOLUTE: 1,
    },
    LOG_STATUS_TYPE: {
        OK: 0,
        FAIL: 1,
        WAITING: 2,
    },
    ROLES: ROLES,
    ROLES_TREE: {
        roleId: ROLES.ROOT, pId: '00000', roleNm: 'Root', hide:true,
        children: [
            {
                roleId: ROLES.TEMPLATE_MANAGEMENT, pId: ROLES.ROOT, roleNm: 'Template Management',
                children: [
                    {
                        roleId: ROLES.EVENT_LIST, pId: ROLES.TEMPLATE_MANAGEMENT, roleNm: 'Event List',
                        children: [
                            {roleId: ROLES.EVENT_BULK_SEND, pId: ROLES.EVENT_LIST, roleNm: 'Event Bulk Send'},
                            {roleId: ROLES.EVENT_SAVE, pId: ROLES.EVENT_LIST, roleNm: 'Event Save'},
                            {roleId: ROLES.EVENT_DELETE, pId: ROLES.EVENT_LIST, roleNm: 'Event Delete'},
                            {
                                roleId: ROLES.TEMPLATE_LIST, pId: ROLES.EVENT_LIST, roleNm: 'Template List',
                                children: [
                                    {roleId: ROLES.TEMPLATE_TEST_SEND, pId: ROLES.TEMPLATE_LIST, roleNm: 'Template Test Send'},
                                    {roleId: ROLES.TEMPLATE_SAVE, pId: ROLES.TEMPLATE_LIST, roleNm: 'Template Save'},
                                    {roleId: ROLES.TEMPLATE_DELETE, pId: ROLES.TEMPLATE_LIST, roleNm: 'Template Delete'},
                                ]
                            },
                        ]
                    },

                ],
            },
            {
                roleId: ROLES.MAIL_LAYOUT_MANAGEMENT, pId: ROLES.ROOT, roleNm: 'Mail Layout Management',
                children: [
                    {
                        roleId: ROLES.MAIL_LAYOUT_LIST, pId: ROLES.MAIL_LAYOUT_MANAGEMENT, roleNm: 'Mail Layout List',
                        children: [
                            {roleId: ROLES.MAIL_LAYOUT_SAVE, pId: ROLES.MAIL_LAYOUT_LIST, roleNm: 'Save'},
                            {roleId: ROLES.MAIL_LAYOUT_DELETE, pId: ROLES.MAIL_LAYOUT_LIST, roleNm: 'Delete'}
                        ]
                    },
                ],
            },
            {
                roleId: ROLES.SEND_LOG, pId: ROLES.ROOT, roleNm: 'Send Log',
            },
            {
                roleId: ROLES.SETTINGS, pId: ROLES.ROOT, roleNm: 'Settings',
                children: [
                    {roleId: ROLES.SETTINGS_CODE, pId: ROLES.SETTINGS, roleNm: 'Code',
                        children:[
                            {roleId: ROLES.SETTINGS_CODE_SAVE, pId: ROLES.SETTINGS_CODE, roleNm: 'Save'}
                        ]
                    },
                    {roleId: ROLES.SETTINGS_USER, pId: ROLES.SETTINGS, roleNm: 'User',
                        children:[
                            {roleId: ROLES.SETTINGS_USER_SAVE, pId: ROLES.SETTINGS_USER, roleNm: 'Save'}
                        ]}
                ]
            }
        ],
    }
}
